module.exports = __webpack_public_path__ + "img/icon-ai-light-purple-gradient.006c393d.svg";